/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
window.PXUTheme.jsSlideshowClassic = {
	init: function($section) {
    // Add settings from schema to current object
    window.PXUTheme.jsSlideshowClassic = $.extend(this, window.PXUTheme.getSectionData($section));

    // Selectors
    const $slideshowClassicEl = $section.find('[data-slideshow-classic]').removeClass('is-hidden');

    const $slideshowClassic = $slideshowClassicEl.flickity({
      wrapAround: true,
      adaptiveHeight: true,
      prevNextButtons: false,
      pageDots: false,
      draggable: true,
      imagesLoaded: true,
      fade: this.image_transition == 'fade' ? true : false,
      autoPlay: this.image_slideshow_speed > 0 ? this.image_slideshow_speed * 1000 : false,
      arrowShape: arrowShape
    });

    // Setup play/pause button
    const $button = $section.find('.slideshow-control-button');
    let isPlaying = this.image_slideshow_speed > 0;
    
    function updateButtonState(playing) {
      isPlaying = playing;
      if (playing) {
        $button.html(`
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true">
            <path d="M8 4V20" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
            <path d="M16 4V20" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
          </svg>
        `).attr('aria-label', 'Pause slideshow');
      } else {
        $button.html(`
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true">
            <path d="M6 3L20 12L6 21V3Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
          </svg>
        `).attr('aria-label', 'Play slideshow');
      }
    }
    
    $button.on('click', function() {
      if (!isPlaying) {
        $slideshowClassic.flickity('playPlayer');
        updateButtonState(true);
      } else {
        $slideshowClassic.flickity('stopPlayer');
        updateButtonState(false);
      }
    });

    // Set initial button state
    updateButtonState(isPlaying);

    // Resize flickity when the slider is settled
    $slideshowClassicEl.on('settle.flickity', function() {
      $slideshowClassicEl.flickity('resize');
    });
  },
  blockSelect: function($section, blockId) {
    const $slider = $section.find('[data-image-slideshow]');
    const $sliderIndex = $('#shopify-section-' + blockId).data('slide-index');

    $slider.flickity('select', $sliderIndex, true, true);
  },
  unload: function($section) {
    const $button = $section.find('.slideshow-control-button');
    $button.off('click');
  }
}

/******/ })()
;